import { render, staticRenderFns } from "./BLLoiPop.vue?vue&type=template&id=0da5f563"
import script from "./BLLoiPop.vue?vue&type=script&lang=js"
export * from "./BLLoiPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da5f563')) {
      api.createRecord('0da5f563', component.options)
    } else {
      api.reload('0da5f563', component.options)
    }
    module.hot.accept("./BLLoiPop.vue?vue&type=template&id=0da5f563", function () {
      api.rerender('0da5f563', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BLLoiPop.vue"
export default component.exports